

import { pdMixin } from '@/mixin/pd/pdMixin'

import PdRevwUnit from '@/components/pd/common/PdRevwUnit.vue' // 리뷰 리스트 unit
import PdRevwCttsSwiper from '@/components/pd/common/PdRevwCttsSwiper.vue' // 리뷰 컨텐츠 리스트 unit
import NoData from '~/components/common/template/NoData.vue'

export default {
  components: {
    NoData,
    PdRevwUnit,
    PdRevwCttsSwiper
  },
  mixins: [pdMixin],
  props: {
    pdNo: {
      type: String,
      default: ''
    },
    pdRevwSmry: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      initActTab: [],
      pageOpt: { // 리뷰 조회 폼
        pageSize: 10, // 한페이지 당 노출 건수
        currentPage: 1, // 조회 페이지
        filter: 'ALL', // 전체 조회
        sortCond: 'RCM', // 추천순
        useCommonPaging: false, // 공통페이징쿼리안탐
      },
      currentPage: 1, // 선택 페이지
      totalCnt: 0, // 리뷰 토탈 갯수
      avgRate: 0, // rate value
      pdRevwAvg: 0, // 리뷰 평점
      pdRevwCnt: 0, // 리뷰 갯수
      pdRevwCttsCnt: 0, // 리뷰 컨텐츠 갯수
      pdRevwAttr: [], // 리뷰 속성
      pdRevwCtts: [], // 리뷰 컨텐츠 정보
      pdRevwList: [], // 노출 리뷰리스트
      pdMdChocRevwList: [], // 에디터 선정 리뷰 리스트
      mdChocRevwSwiperOpt: { // 에디터 선정 리뷰 스와이퍼 옵션
        slidesPerView: 3,
        spaceBetween: 8,
        lazy: true,
        navigation: {
          nextEl: '.review-list .swiper-button-next',
          prevEl: '.review-list .swiper-button-prev'
        }
      },
      revwFilter: 'ALL', // 리뷰 조회 필터
      // 23.08.18 select 데이터 변경
      revwSortList: [{ // 리뷰 정렬 조건
        value: 'RCM',
        label: '추천순'
      }, {
        value: 'LAT',
        label: '최신순'
      }, {
        value: 'HSTAR',
        label: '별점높은순'
      }, {
        value: 'RSTAR',
        label: '별점낮은순'
      }]
    }
  },
  computed: {

  },
  mounted () {
    // 리뷰 정보 조회
    const revw = this.pdRevwSmry
    this.pdRevwAvg = this.isNotEmpty(revw.pdRevw) ? parseFloat(revw.pdRevw.revwAvg).toFixed(1) : 0 // 리뷰 평점
    this.pdRevwCnt = this.isNotEmpty(revw.pdRevw) ? parseFloat(revw.pdRevw.revwCnt) : 0 // 리뷰 갯수
    this.avgRate = parseFloat(this.pdRevwAvg)

    this.pdRevwAttr = [] // 리뷰 항목 초기화
    revw.pdRevwAttr.forEach((item, idx) => {
      this.initActTab.push(String(idx + 1))
      const obj = {
        mostAttr: {},
        revwIemCd: item.revwIemCd, // 리뷰 항목 코드
        revwIemNm: item.revwIemNm, // 리뷰 항목 명
        qsnCn: item.qsnCn, // 리뷰 항목 질문
        list: [
          { id: 'attr1', nm: item.revwAttrNm1, perc: item.perc1, cnt: item.attr1, most: false },
          { id: 'attr2', nm: item.revwAttrNm2, perc: item.perc2, cnt: item.attr2, most: false },
          { id: 'attr3', nm: item.revwAttrNm3, perc: item.perc3, cnt: item.attr3, most: false },
          { id: 'attr4', nm: item.revwAttrNm4, perc: item.perc4, cnt: item.attr4, most: false },
          { id: 'attr5', nm: item.revwAttrNm5, perc: item.perc5, cnt: item.attr5, most: false }
        ]
      }
      this.pdRevwAttr.push(obj)

      let totalPerc = this.pdRevwAttr[idx].list.reduce((n, { perc }) => n + perc, 0) // 리뷰항목 선택 값 전체 퍼센트 합계를 구함
      const max = this.pdRevwAttr[idx].list.filter(o => o.cnt === item.maxAttr) // 리뷰항목 중 가장 높은 값의 object
      this.pdRevwAttr[idx].list = this.pdRevwAttr[idx].list.filter(o => this.isNotEmpty(o.nm)) // 리뷰항목 리스트에서 값이 없는 데이터 제거

      // 리뷰항목 중 가장 높은 값 셋팅 ( 전체 합계 100 만들기 )
      const addVal = (100 - totalPerc) / max.length
      max.forEach((m, i) => {
        const obj = this.pdRevwAttr[idx].list.find(e => e.id === m.id)
        if (i === 0) { obj.most = true } // max가 몇개든 index 가 0인 항목이 무조건 max(most)
        obj.perc += Math.floor(addVal) // 100에서 뺏을 때 나머지가 정수로 떨어지게 계산된값을 버림으로 더함
        totalPerc = this.pdRevwAttr[idx].list.reduce((n, { perc }) => n + perc, 0) // 전체 퍼센트 합계 재설정
      })
      this.pdRevwAttr[idx].mostAttr = { id: max[0].id, nm: max[0].nm, perc: max[0].perc + (100 - totalPerc) }
    })

    this.selRevwList(false) // 리뷰 리스트 조회(리로드 플래그)
  },

  methods: {

    // 리뷰 리스트 조회
    async selRevwList (reload) {
      try {
        await this.$AxiosBuilder
          .data({ pdNo: this.pdNo, ...this.pageOpt })
          .build()
          .post('/pd/pds/revw/selRevwList')
          .then((res) => {
            const result = res.data.data
            this.pdRevwList = []
            this.totalCnt = result.pdRevwList.length > 0 ? result.pdRevwList[0].totalCnt : 0 // 리뷰 토탈 갯수
            this.currentPage = this.pageOpt.currentPage // 페이지 셋팅
            const pdTy = result.pdData[0].pdTy

            result.pdRevwList.forEach((revw, idx) => {
              if (pdTy === '05') {
                revw.optCn = revw.exhPdNm
              }
              const cttsList = []
              revw.ctts.forEach((c, i) => {
                let videoOpt = {}
                if (c.pdCttsTy === '02' && this.isNotEmpty(c.imgUrl)) { // 동영상이고 url이 있을 때 비디오 옵션 추가
                  videoOpt = { // video 기본 옵션 설정
                    controls: false, // 컨트롤 바 노출 여부
                    autoplay: false, // 자동재생
                    muted: true, // 음소거
                    loop: false, // 반복재생
                    preload: 'auto', // 즉시 비디오 데이터를 다운로드 시작할지 여부 결정
                    poster: '', // 썸네일 이미지
                    controlBar: { // 컨트롤 바에 들어갈 옵션 설정
                      playToggle: false, // 플레이 버튼
                      pictureInPictureToggle: false, // 작은 창으로 새로 띄워(항상 위) 비디오 시청 가능
                      remainingTimeDisplay: true, // 남은시간 표기
                      progressControl: false, // 프로세스 컨트롤러 유무
                      qualitySelector: true // 품질선택 창
                    },
                    playbackRates: [1] // 배속
                  }
                }
                const obj = {
                  id: 'review' + String(idx),
                  pdCttsTy: c.pdCttsTy, // 컨텐츠 유형 (01: 이미지, 02: 동영상)
                  imgUrl: c.imgUrl, // url
                  videoOpt
                }
                cttsList.push(obj)
              })
              this.pdRevwList.push({ cttsList, ...revw })
            })

            if (!reload) { // 최초 조회시 md 추천 리뷰 셋팅(조회조건 변경에도 데이터가 변하면 안됨)
              this.pdMdChocRevwList = result.pdMdChocRevwList
            }
          })
      } catch (e) {
        console.log('SCR_PDR_0001_5 selRevwList error : ', e)
      }
    },

    // 조회조건 변경으로 인한 재조회
    changeFilter () {
      // 페이징 셋팅(페이징 변경이 없을 시 다른 필터 변경으로 페이지 1로 조회)
      this.pageOpt.currentPage = this.pageOpt.currentPage === this.currentPage ? 1 : this.currentPage

      // 스크롤 이동(리뷰리스트 상단)
      const wrap = document.getElementsByClassName('content-section')[0].closest('.wrap')
      wrap.scrollTo({ top: this.$refs.revwList.offsetTop - (182 + 58), left: 0, behavior: 'smooth' })

      // 리뷰 리스트 조회
      this.selRevwList(true) // 리뷰 리스트 조회(리로드 플래그)
    },

    // 리뷰 추천 토글
    tglRevwRcm (revwMngNo) {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }
      try {
        this.$AxiosBuilder
          .data({ revwMngNo })
          .build()
          .post('/pd/pds/revw/tglRevwRcm')
          .then((res) => {
            if (res.data.success) {
              const rcmFlag = res.data.extraData.rcmYn
              this.pdRevwList.map((o) => {
                if (o.revwMngNo === revwMngNo) {
                  o.rcmYn = rcmFlag ? 'Y' : 'N'
                  o.rcmCont = rcmFlag ? o.rcmCont + 1 : o.rcmCont - 1
                }
                return o
              })
            } else {
              this.alert(res.data.message)
            }
          })
      } catch (e) {
        console.log('SCR_PDR_0001_5 tglRevwRcm error : ', e)
      }
    },

    // 리뷰 컨텐츠 건수 셋팅
    setRevwCttsCnt (val) {
      this.pdRevwCttsCnt = val
    },

    // 사진 & 동영상 컨텐츠 전체보기(팝업)
    openLayerRevwCttsClt () {
      this.$emit('openLayerRevwCttsClt', { name: 'revwCttsClt', data: { pdNo: this.pdNo } })
    },

    // 리뷰 상세 보기 레이어 팝업
    openLayerRevwDtl (data) {
      this.$emit('openLayerRevwDtl', { name: 'revwDtl', ...data })
    },

    // 리뷰 신고 팝업
    openLayerRevwStmt (data) {
      this.$emit('openLayerRevwStmt', { name: 'revwStmt', ...data })
    },

    setRevwCttsList () {
      this.$emit('revwCttsList')
    }
  }
}
